import { getFunctions, httpsCallable } from "firebase/functions";

// Configure functions to use asia-southeast1 region
const functions = getFunctions(undefined, 'asia-southeast1');

export const getAvailableSlots = async (payload) => {
  const fn = httpsCallable(functions, "getAvailableSlots");
  const { data } = await fn(payload);
  return data;
};

export const submitBookingRequest = async (payload) => {
  const fn = httpsCallable(functions, "submitBookingRequest");
  const { data } = await fn(payload);
  return data;
};
